export const HEADLINE = "a unique studio";
export const TITLE = "An entire team of experts working with you.";
export const PARAGRAPH = "The uniqueness of The Gini-Apps Studio lies in the way we work. \n" +
    "An entire team of product strategists and designers \n" +
    "collaborate on each project, applying a user-first approach to craft bespoke digital products and seamless user experiences. \n" +
    "Our studio is trusted by the leading tech companies, to design products used by millions of users around the globe.";
export const LETS_TALK = "Let's Talk";
